import { render, staticRenderFns } from "./Procedures.vue?vue&type=template&id=7e0ea154"
import script from "./Procedures.vue?vue&type=script&lang=js"
export * from "./Procedures.vue?vue&type=script&lang=js"
import style0 from "./Procedures.vue?vue&type=style&index=0&id=7e0ea154&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports